<template>
  <div style="text-align: center">
    <van-nav-bar
      id="reset"
      title="绝对禁忌症"
      left-text="上一步"
      left-arrow
      @click-left="goback"
    />
    <!-- <h3>请确认您是否有如下疾病：</h3> -->
    <h3>您是否有以下任一情况</h3>
    <van-form  input-align="right">
      <van-field
        name="switch"
        label="1.急性心梗(2天内) 或心肌梗塞合并室壁瘤"
        :label-width="labelWidth"
      >
        <template #input>
          <van-switch v-model="ac1" size="20" inactive-color="#9C9C9C"/>
        </template>
      </van-field>
      <van-field
        name="switch"
        label="2.中、重度瓣膜病或先天性心脏病"
        :label-width="labelWidth"
      >
        <template #input>
          <van-switch v-model="ac2" size="20" inactive-color="#9C9C9C" />
        </template>
      </van-field>
      <van-field
        name="switch"
        label="3.急性心肌炎、心包炎、风湿热、感染性心内膜炎"
        :label-width="labelWidth"
      >
        <template #input>
          <van-switch v-model="ac3" size="20" inactive-color="#9C9C9C"/>
        </template>
      </van-field>
      <van-field
        name="switch"
        label="4.严重高血压、显著低血压"
        :label-width="labelWidth"
      >
        <template #input>
          <van-switch v-model="ac4" size="20" inactive-color="#9C9C9C"/>
        </template>
      </van-field>
      <van-field
        name="switch"
        label="5.运动引起加重或影响运动的非心源性疾病"
        :label-width="labelWidth"
      >
        <template #input>
          <van-switch v-model="ac5" size="20" inactive-color="#9C9C9C"/>
        </template>
      </van-field>
      <van-field
        name="switch"
        label="6.未控制的不稳定型心绞痛，症状明显心力衰竭"
        :label-width="labelWidth"
      >
        <template #input>
          <van-switch v-model="ac6" size="20" inactive-color="#9C9C9C"/>
        </template>
      </van-field>
      <van-field
        name="switch"
        label="7.产生症状或血流动力学障碍的未控制心律失常"
        :label-width="labelWidth"
      >
        <template #input>
          <van-switch v-model="ac7" size="20" inactive-color="#9C9C9C"/>
        </template>
      </van-field>
      <van-field name="switch" label="8.严重的主动脉狭窄" :label-width="labelWidth">
        <template #input>
          <van-switch v-model="ac8" size="20" inactive-color="#9C9C9C"/>
        </template>
      </van-field>
      <van-field name="switch" label="9.肺栓塞、肺梗塞" :label-width="labelWidth">
        <template #input>
          <van-switch v-model="ac9" size="20" inactive-color="#9C9C9C"/>
        </template>
      </van-field>
      <!-- <van-field name="switch" label="是否接受运动试验" :label-width="labelWidth">
        <template #input>
          <van-switch v-model="ac10" size="20" inactive-color="#9C9C9C"/>
        </template>
      </van-field> -->

      <div style="margin: 16px">
        <van-button
          type="warning"
          block
          native-type="submit"
          class="nextStepBtn"
          @click="nextStep"
          :disabled="disabled"
          >
            本人确认上述情况属实并自愿接受运动试验
          </van-button
        >
      </div>
      <van-popup v-model="InstructionsShow" class="InstructionsContainer">
        <Instructions />
      </van-popup>
    </van-form>
  </div>
</template>

<script type="text/ecmascript-6">
import Instructions from './instructions.vue';
export default {
  components: { Instructions },
  name: "login",
  data() {
    return {
      InstructionsShow: false,
      labelWidth:"80%",
      ac1: false,
      ac2: false,
      ac3: false,
      ac4: false,
      ac5: false,
      ac6: false,
      ac7: false,
      ac8: false,
      ac9: false,
      // ac10: true,
    };
  },
  computed: {
    disabled() {
      if (
        this.ac1 == false &&
        this.ac2 == false &&
        this.ac3 == false &&
        this.ac4 == false &&
        this.ac5 == false &&
        this.ac6 == false &&
        this.ac7 == false &&
        this.ac8 == false &&
        this.ac9 == false 
        // this.ac10 == true
      ) {
        return false;
      } else {
        return true;
      }
    },
  },
  watch: {
    ac1(newName, oldName) {
      if (newName == true) {
        this.$message({
          type: "warning",
          message: "您有绝对禁忌症，不适合做本检测！",
        });
        console.log(oldName);
      }
    },
    ac2(newName, oldName) {
      if (newName == true) {
        this.$message({
          type: "warning",
          message: "您有绝对禁忌症，不适合做本检测！",
        });
        console.log(oldName);
      }
    },
    ac3(newName, oldName) {
      if (newName == true) {
        this.$message({
          type: "warning",
          message: "您有绝对禁忌症，不适合做本检测！",
        });
        console.log(oldName);
      }
    },
    ac4(newName, oldName) {
      if (newName == true) {
        this.$message({
          type: "warning",
          message: "您有绝对禁忌症，不适合做本检测！",
        });
        console.log(oldName);
      }
    },
    ac5(newName, oldName) {
      if (newName == true) {
        this.$message({
          type: "warning",
          message: "您有绝对禁忌症，不适合做本检测！",
        });
        console.log(oldName);
      }
    },
    ac6(newName, oldName) {
      if (newName == true) {
        this.$message({
          type: "warning",
          message: "您有绝对禁忌症，不适合做本检测！",
        });
        console.log(oldName);
      }
    },
    ac7(newName, oldName) {
      if (newName == true) {
        this.$message({
          type: "warning",
          message: "您有绝对禁忌症，不适合做本检测！",
        });
        console.log(oldName);
      }
    },
    ac8(newName, oldName) {
      if (newName == true) {
        this.$message({
          type: "warning",
          message: "您有绝对禁忌症，不适合做本检测！",
        });
        console.log(oldName);
      }
    },
    ac9(newName, oldName) {
      if (newName == true) {
        this.$message({
          type: "warning",
          message: "您有绝对禁忌症，不适合做本检测！",
        });
        console.log(oldName);
      }
    },
    // ac10(newName, oldName) {
    //   if (newName == false) {
    //     this.$message({
    //       type: "warning",
    //       message: "只有选择接受运动检测才能进行预约！",
    //     });
    //     console.log(oldName);
    //   }
    // },
  },
  // 创建完毕状态(里面是操作)
  created() {},
  // 里面的函数只有调用才会执行
  methods: {
    testWarnings() {
      this.$router.push({path:"/appIndex/instructions"})
    },
    nextStep() {
      //如果没有绝对禁忌症
      if (
        this.ac1 == false &&
        this.ac2 == false &&
        this.ac3 == false &&
        this.ac4 == false &&
        this.ac5 == false &&
        this.ac6 == false &&
        this.ac7 == false &&
        this.ac8 == false &&
        this.ac9 == false
      ) {
        // // 如果没有绝对禁忌症  但 不接受运动检测
        // if (this.ac10 == false) {
        //   this.$notify({
        //     message: "请选择接受运动测试！",
        //     type: "warning",
        //   });
        // }
        // //如果没有绝对禁忌症 且 接受 运动检测
        // else {
          //既往病史 改到 护士页面，用户不用填写既往病史
          // this.$router.push({ path: "/appIndex/medicalHistory" });
          this.InstructionsShow = true;
          
        // }
      }
      //如果有绝对禁忌症
      else {
        this.$notify({
          message: "您有绝对禁忌症，不适合做本检测！",
          type: "warning",
        });
      }
    },
    goback() {
      this.$router.go(-1);
    },
  },
};
</script>

<style scoped>

/**style for top bar */
.van-nav-bar {
  background: linear-gradient(to right, #77bbe3, #1270c6);
}
#reset /deep/ .van-ellipsis {
  font-size: 18px;
  color: white !important;
}
#reset /deep/ .van-nav-bar__text {
  color: white !important;
}
/** top bar style end*/

.fr {
  float: right;
}
.InstructionsContainer{
  width: 344px;
  height: 590.76px;
  text-align: left;
}
</style>